import type { WorkflowApprovalLabelTone } from './approval-settings/public';
import type { ValueBadgeTone } from '../../design-system';

export const workflowApprovalLabelBadgeTone = {
  GREEN: 'success',
  BLUE: 'info',
  PURPLE: 'accent',
  AMBER: 'warning',
  CYAN: 'teal',
  GRAY: 'neutral',
} as const satisfies Record<WorkflowApprovalLabelTone, ValueBadgeTone>;

export const workflowApprovalLabelToneLabel: Record<WorkflowApprovalLabelTone, string> = {
  GREEN: '초록',
  BLUE: '파랑',
  PURPLE: '보라',
  AMBER: '주황',
  CYAN: '청록',
  GRAY: '회색',
};
